// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1awQN","row":"ProcedureTreatmentSummary_row__3Ouox"};